module.exports = __webpack_public_path__ + "img/tencentcloud.f0f84618.svg";